import moment from "moment";
import {
  IS_LOADING,
  SELECT_SELECTPDC,
  PLANNING_SELECT_EMAIL,
  SELECT_EVENT,
  DISPLAY_PDC_FORM,
  PLANNING_SET_ALL_SECTORSLIST,
  PLANNING_MODAL_LOADING,
  PLANNING_SET_USER_PDCSLIST,
  PLANNING_SET_TYPES_VISIT,
  PLANNING_SET_KEY_FILTER_SELECTED,
  PLANNING_AGENDA_LOADING,
  PLANNING_SET_FILTERS,
  PLANNING_SELECT_USER_SECTOR,
  PLANNING_SELECT_USER_PDC,
  PLANNING_SELECT_USER_TYPEVISIT,
  PLANNING_SET_EVENTS,
  PLANNING_SELECT_DATE,
  PLANNING_SET_CURRENT_FILTERS,
  PLANNING_SET_REQUEST_RESPONSE,
  PLANNING_SET_AVAILABLE_DATE_RANGE,
  PLANNING_SET_EVENT_TYPES,
  PLANNING_SET_CURRENT_DATE_RANGE,
  PLANNING_SET_LUCCA_VACATION_DAYS,
  PLANNING_SELECT_PDC_ID
} from "./../types";

import { createReducer } from "./functions";

export const defaultStartDate = moment()
  .startOf("week")
  .valueOf();
export const defautlEndDate = moment()
  .endOf("week")
  .valueOf();

const initialState = {
  requestResponse: {},
  isLoading: false,
  selectedEmail: undefined,
  selectedSector: undefined,
  selectedPdc: undefined,
  selectedPdcId: undefined,
  selectedEvent: undefined,
  selectedTypeVisit: undefined,
  currentDateRange: { start: defaultStartDate, end: defautlEndDate },
  selectedDate: moment().valueOf(),
  allSectorsList: [],
  modalIsLoading: false,
  typesVisit: [],
  userPdcs: [],
  keyFilterSelected: null,
  agendaIsLoading: false,
  filters: null,
  currentFilters: {},
  pdcsList: null,
  currentEvent: {},
  usersList: null,
  events: [],
  luccaVacationDays: [],
  availableDates: []
};

const selectPdcHandlers = {
  [SELECT_SELECTPDC]: (state, action) => {
    return { ...state, selectedPdc: action.payload };
  }
};
const selectPdcIdHandlers = {
  [PLANNING_SELECT_PDC_ID]: (state, action) => {
    return { ...state, selectedPdcId: action.payload };
  }
};

const selectEventHandlers = {
  [SELECT_EVENT]: (state, action) => {
    return { ...state, selectedEvent: action.payload };
  }
};

const isLoadingHandlers = {
  [IS_LOADING]: (state, action) => {
    return { ...state, isLoading: action.payload };
  }
};

const displayPDCForm = {
  [DISPLAY_PDC_FORM]: (state, action) => {
    return { ...state, displayPDCForm: action.value };
  }
};

const setCurrentDateRange = {
  [PLANNING_SET_CURRENT_DATE_RANGE]: (state, action) => {
    return { ...state, currentDateRange: action.payload };
  }
};

const setAvailableDateRange = {
  [PLANNING_SET_AVAILABLE_DATE_RANGE]: (state, action) => {
    return {
      ...state,
      availableDates: action.payload
    };
  }
};

const setCurrentFilters = {
  [PLANNING_SET_CURRENT_FILTERS]: (state, action) => {
    return { ...state, currentFilters: action.currentFilters };
    const currentFilters = { ...state.currentFilters, ...action.currentFilters };

    return Object.assign({}, state, {
      currentFilters: currentFilters
    });
  }
};

const setKeyFilterSelected = {
  [PLANNING_SET_KEY_FILTER_SELECTED]: (state, action) => {
    return { ...state, keyFilterSelected: action.key };
  }
};

const setAllSectorsList = {
  [PLANNING_SET_ALL_SECTORSLIST]: (state, action) => {
    return { ...state, allSectorsList: action.payload };
  }
};

const setUserPdcsList = {
  [PLANNING_SET_USER_PDCSLIST]: (state, action) => {
    return { ...state, userPdcs: action.payload };
  }
};

const setTypesVisitList = {
  [PLANNING_SET_TYPES_VISIT]: (state, action) => {
    return { ...state, typesVisit: action.payload };
  }
};

const setEventTypesList = {
  [PLANNING_SET_EVENT_TYPES]: (state, action) => {
    return { ...state, eventTypes: action.payload };
  }
};

const modalIsLoading = {
  [PLANNING_MODAL_LOADING]: (state, action) => {
    return { ...state, modalIsLoading: action.loading };
  }
};

const agendaIsLoading = {
  [PLANNING_AGENDA_LOADING]: (state, action) => {
    return { ...state, agendaIsLoading: action.loading };
  }
};

const setFilters = {
  [PLANNING_SET_FILTERS]: (state, action) => {
    let newFilters = { ...state.filters };
    if (action.key === "pdc_id") {
      if (!action.values) return { ...state, filters: newFilters };
      const filter_pdcs = action.values.map(pdc => pdc.pdc_id);
      newFilters[action.key] = filter_pdcs;
      return { ...state, filters: newFilters, pdcsList: action.values };
    } else if (action.key === "email") {
      const filter_emails = action.values.map(user => user.email);
      newFilters[action.key] = filter_emails;
      return { ...state, filters: newFilters, usersList: action.values };
    } else if (action.key === "sector_label") {
      if (!action.values) return { ...state, filters: newFilters };
      const filter_sectors = action.values.map(sector => sector.sector_label);
      newFilters[action.key] = filter_sectors;
      return { ...state, filters: newFilters, sectorsList: action.values };
    } else {
      newFilters[action.key] = action.values;
      return { ...state, filters: newFilters };
    }
  }
};

const selectEmailHandlers = {
  [PLANNING_SELECT_EMAIL]: (state, action) => {
    return { ...state, selectedEmail: action.payload };
  }
};
const selectDateHandlers = {
  [PLANNING_SELECT_DATE]: (state, action) => {
    return { ...state, selectedDate: action.payload };
  }
};

const selectSectorHandlers = {
  [PLANNING_SELECT_USER_SECTOR]: (state, action) => {
    return { ...state, selectedSector: action.payload };
  }
};

const selectPdcUser = {
  [PLANNING_SELECT_USER_PDC]: (state, action) => {
    return { ...state, selectedPdc: action.payload };
  }
};
const selectTypeVisitUser = {
  [PLANNING_SELECT_USER_TYPEVISIT]: (state, action) => {
    return { ...state, selectedTypeVisit: action.payload };
  }
};

const setAllEventsList = {
  [PLANNING_SET_EVENTS]: (state, action) => {
    return { ...state, events: action.payload };
  }
};

const setLuccaVacationDays = {
  [PLANNING_SET_LUCCA_VACATION_DAYS]: (state, action) => {
    return { ...state, luccaVacationDays: action.payload || [] };
  }
};

const setRequestResponse = {
  [PLANNING_SET_REQUEST_RESPONSE]: (state, action) => {
    return { ...state, requestResponse: action.response };
  }
};

const planningReducer = createReducer(initialState, {
  ...isLoadingHandlers,
  ...selectEmailHandlers,
  ...selectSectorHandlers,
  ...selectPdcHandlers,
  ...selectEventHandlers,
  ...displayPDCForm,
  ...setAllSectorsList,
  ...modalIsLoading,
  ...setTypesVisitList,
  ...setEventTypesList,
  ...setUserPdcsList,
  ...setKeyFilterSelected,
  ...agendaIsLoading,
  ...setFilters,
  ...selectPdcUser,
  ...selectTypeVisitUser,
  ...setAllEventsList,
  ...setLuccaVacationDays,
  ...setCurrentFilters,
  ...setRequestResponse,
  ...setAvailableDateRange,
  ...selectDateHandlers,
  ...setCurrentDateRange,
  ...selectPdcIdHandlers
});

export default planningReducer;



// WEBPACK FOOTER //
// src/redux/reducers/planningReducer.js